<div class="container">
  <div class="object-container">
    <app-section-header title="{{ 'workOrderObjectHierarchy.workLines' | translate }}"></app-section-header>

    <div class="table-header">
      @if (workOrder) {
        <div>
          <div class="work-order-number">{{ workOrder.workOrderNumber }}</div>
        </div>
      }
      <div class="select-all-objects-placeholder">
        <mat-checkbox
          class="mat-checkbox-xl"
          labelPosition="before"
          [formControl]="selectAllObjects"
          (change)="toggleAllObjects()"
          >{{ 'workOrderObject.selectAll' | translate }}</mat-checkbox
        >
      </div>
    </div>
    <div class="object-header">
      <div class="object-number">
        {{ 'workOrderObject.objectNumber' | translate }}
      </div>
      <div class="object-progress">
        {{ 'workOrderObject.progress' | translate }}
      </div>
      <div class="object-select">
        {{ 'workOrderObject.select' | translate }}
      </div>
      <div class="object-expand"></div>
    </div>

    @if (objects?.length > 0) {
      <div class="filter-row" role="search">
        <div class="filter-col-main">
          <div class="filter-chip filter-search">
            <svg class="filter-icon" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">
              <path
                fill="currentColor"
                d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
              />
            </svg>
            <input
              type="text"
              class="filter-input"
              [(ngModel)]="filters.search"
              (ngModelChange)="applyFilters()"
              placeholder="{{ 'workOrderObjectHierarchy.filters.search' | translate }}"
              attr.aria-label="{{ 'workOrderObjectHierarchy.filters.search' | translate }}"
            />
            @if (filters.search) {
              <button
                type="button"
                class="filter-clear"
                attr.aria-label="{{ 'workOrderObjectHierarchy.filters.clear' | translate }}"
                (click)="clearSearch()"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>

          @if (workTypeOptions.length > 1) {
            <div class="filter-chip filter-worktype">
              <svg class="filter-icon" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">
                <path
                  fill="currentColor"
                  d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
                />
              </svg>
              <select
                class="filter-select"
                [(ngModel)]="filters.workType"
                (ngModelChange)="applyFilters()"
                attr.aria-label="{{ 'workOrderObjectHierarchy.filters.workType' | translate }}"
              >
                <option value="">{{ 'workOrderObjectHierarchy.filters.allWorkTypes' | translate }}</option>
                @for (type of workTypeOptions; track type) {
                  <option [value]="type">{{ type }}</option>
                }
              </select>
              <svg
                class="filter-select-arrow"
                viewBox="0 0 24 24"
                width="20"
                height="20"
                aria-hidden="true"
                focusable="false"
              >
                <path fill="currentColor" d="M7 10l5 5 5-5z" />
              </svg>
            </div>
          }
        </div>

        <div class="filter-col-side">
          <div class="filter-chip filter-kind">
            <svg class="filter-icon" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">
              <path
                fill="currentColor"
                d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
              />
            </svg>
            <select
              class="filter-select"
              [(ngModel)]="filters.progressType"
              (ngModelChange)="applyFilters()"
              attr.aria-label="{{ 'workOrderObjectHierarchy.filters.type' | translate }}"
            >
              <option value="">{{ 'workOrderObjectHierarchy.filters.allTypes' | translate }}</option>
              @for (progressType of progressTypeOptions; track progressType) {
                <option [value]="progressType">{{ progressType }}</option>
              }
            </select>
            <svg
              class="filter-select-arrow"
              viewBox="0 0 24 24"
              width="20"
              height="20"
              aria-hidden="true"
              focusable="false"
            >
              <path fill="currentColor" d="M7 10l5 5 5-5z" />
            </svg>
          </div>

          <div class="filter-chip filter-status">
            <svg class="filter-icon" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">
              <path
                fill="currentColor"
                d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
              />
            </svg>
            <select
              class="filter-select"
              [(ngModel)]="filters.status"
              (ngModelChange)="applyFilters()"
              attr.aria-label="{{ 'workOrderObjectHierarchy.selectStatus' | translate }}"
            >
              <option value="">{{ 'workOrderObjectHierarchy.filters.allStatuses' | translate }}</option>
              <option value="notStarted">{{ 'workOrderObjectHierarchy.filters.notStarted' | translate }}</option>
              <option value="inProgress">{{ 'workOrderObjectHierarchy.filters.inProgress' | translate }}</option>
              <option value="completed">{{ 'workOrderObjectHierarchy.filters.completed' | translate }}</option>
            </select>
            <svg
              class="filter-select-arrow"
              viewBox="0 0 24 24"
              width="20"
              height="20"
              aria-hidden="true"
              focusable="false"
            >
              <path fill="currentColor" d="M7 10l5 5 5-5z" />
            </svg>
          </div>
        </div>

        @if (hasActiveFilters()) {
          <button
            class="filter-clear-all"
            type="button"
            (click)="clearFilters()"
            attr.aria-label="{{ 'workOrderObjectHierarchy.filters.clearAll' | translate }}"
            title="{{ 'workOrderObjectHierarchy.filters.clearAll' | translate }}"
          >
            <mat-icon>filter_alt_off</mat-icon>
          </button>
        }
      </div>
    }
    @if (objects?.length === 0) {
      <app-empty-list info="{{ 'workOrderObjectHierarchy.empty.info' | translate }}"></app-empty-list>
    }
    @if (objects?.length > 0 && visibleObjects.length === 0) {
      <app-empty-list
        icon="filter_alt_off"
        title="{{ 'workOrderObjectHierarchy.filters.noResultsTitle' | translate }}"
        info="{{ 'workOrderObjectHierarchy.filters.noResultsInfo' | translate }}"
      ></app-empty-list>
    }
    @for (object of visibleObjects; track object) {
      <div class="object-list">
        <div class="object-list-item">
          <app-object
            [workOrder]="workOrder"
            [object]="object"
            [showProgress]="true"
            [level]="0"
            [statusCodes]="statusCodes"
            [objectList]="objects"
            [filters]="filters"
          >
          </app-object>
          <div class="object-list-footer"></div>
        </div>
      </div>
    }
  </div>

  @if (hasSelectedItems) {
    <app-report-progress-footer (destroyingElement)="clearSelection()"></app-report-progress-footer>
  }
</div>
